import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input, Row, Col, Typography, Space, Select, message, Affix, Spin } from "antd";
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';
import Cookies from 'js-cookie';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import { MAX_VERTICAL_CONTENT_RADIUS } from "antd/es/style/placementArrow";
import DynamicPicklistComponent from '../Components/MultiSelectPicklistComponent';


const { Title } = Typography;
const { Option } = Select;

const ReportEditor = ({ onBack, fetchAllReports, selectedReport }) => {
    const [form] = Form.useForm();
    const [objects, setAllObjects] = useState([]);
    const [fields, setFields] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]);
    const [groupFields, setGroupFields] = useState([]);
    const [aggregationFields, setAggregationFields] = useState([]);
    const [loading, setLoading] = useState(false); // Add loading state
    const currentUserId = Cookies.get('userId');
    const [logic, setLogic] = useState('');
    const [lookupOptions, setLookupOptions] = useState([]); // For storing lookup options
    const [operator, setOperator] = useState('AND');
    const [isLogicEditable, setIsLogicEditable] = useState(false);
    const [filters, setFilters] = useState([{ 1: { field: '', value: '', displayValue: '' } }]); // For managing filters
    const [valueOperator, setValueOperator] = useState('');


    useEffect(() => {
        if (selectedReport) {


            form.setFieldsValue({
                model: selectedReport.model,
                name: selectedReport.name,
                description: selectedReport.description,
                chart_type: selectedReport.chart_type,
                group_fields: selectedReport.group_fields || [],
                aggregation_fields: selectedReport.aggregation_fields || [],
            });

            const existingFilters = selectedReport.filters
                ? Object.entries(selectedReport.filters).map(([key, { field, value }]) => {
                    let operator = '';
                    let actualValue = '';
                    if (typeof value === 'object' && value !== null && Object.keys(value)[0] !== "0") {
                        operator = Object.keys(value)[0];
                        actualValue = value[operator];
                    } else {
                        actualValue = value; // Extract the actual value (e.g., '50')
                    }
                    let op = '';
                    if (operator !== '') {
                        try {
                            setValueOperator(operator);
                            op = operator;
                        } catch (error) {
                            // Handle the error gracefully
                            setValueOperator(''); // or any default value
                        }
                    } else {
                        op = '';
                    }
                    // Handle display value for Current User
                    const displayValue = actualValue === "CURRENT_USER" ? "Current User" : actualValue;
                    
                    return {
                        field,
                        value: value,
                        displayValue: displayValue,
                        operator: op
                    };
                })
                : [{ field: '', value: '', operator: '' }];
            setFilters(existingFilters); // Set filters state here
            fetchLookupRecordsForExistingFilters(existingFilters);
            setSelectedFields(selectedReport?.fields_to_display);
            setLogic(selectedReport?.filter_logic);

            if (selectedReport.model) {
                fetchfields(selectedReport.model);
            }
        }
    }, [selectedReport, form]);

    useEffect(() => {
        if (selectedReport && (filters !== null || filters !== undefined)) {
          fetchLookupRecordsForExistingFilters(filters);
        }
      }, [fields])

    const handleSubmit = async (values) => {
        console.log('filters', filters);
       
        const filterObj = filters.reduce((acc, filter, index) => {
            if (filter.field) {
                acc[index + 1] = {
                    field: filter.field,
                    value: filter.operator && (filter.value === undefined || filter.value === "")
                        ? { [filter.operator]: "" }  // If operator exists and value is empty or undefined, set as JSON object
                        : (filter.value === undefined ? "" : filter.value)  // If value is undefined, set it to an empty string
                };
            }
            return acc;
          }, {});
          console.log('filterObj', filterObj);
          
          let filterLogic = '';
          const filterObjKeys = Object.keys(filterObj);
          if (filterObjKeys.length === 1) {
              filterLogic = '1';
          } else if (filterObjKeys.length > 1) {
              filterLogic = logic || '';
          }
      
          console.log('filterLogic', filterLogic);
          
    const body = {
        mt_report: {
          model: values.model,
          name: values.name,
          description: values.description,
          filters: filterObj || {},
          chart_type:values.chart_type,
          fields_to_display: selectedFields || [],
          group_fields: values.group_fields || [],
          filter_logic: filterLogic,
          aggregation_fields: values.aggregation_fields || [],
        },
      };
      
      
        let apiService = '';

        if (selectedReport?._id) {
        
            apiService = new ApiService(
                `${BASE_URL}/mt_reports/${selectedReport._id}`,
                { 'Content-Type': 'application/json' },
                'PATCH',
                 body 
            );
        } else {
            apiService = new ApiService(
                `${BASE_URL}/mt_reports`,
                { 'Content-Type': 'application/json' },
                'POST',
                body 
            );
        }

        // Set loading to true before the API call
        setLoading(true);

        try {
            const response = await apiService.makeCall();
            message.success("Report saved successfully!");
            form.resetFields();
            setFields([]);
            setFilters([]);
            setLogic('');
            fetchAllReports();
            onBack();
        } catch (error) {
            message.error("Failed to save the report.");
        } finally {
            // Set loading to false after the API call completes
            setLoading(false);
        }
    };

    const fetchObjects = async () => {
        try {
            const apiService = new ApiService(
                `${BASE_URL}/mt_objects`,
                { 'Content-Type': 'application/json' },
                'GET',
            );

            const response = await apiService.makeCall();
            setAllObjects(response);
        } catch (error) {
            message.error("Failed to fetch objects.");
        }
    };

    useEffect(() => {
        fetchObjects();
    }, [currentUserId]);

    const fetchfields = async (objectName) => {
        
        try {
            const apiService = new ApiService(
                `${BASE_URL}/mt_fields/object/${objectName}`,
                { 'Content-Type': 'application/json' },
                'GET',
            );

            const response = await apiService.makeCall();
            const group = response;
            const aggregation = response.filter(field => 
                (field.type === 'integer' || field.type === 'decimal' || field.type === 'currency' || field.type === 'rollup' || field.is_formula === true) && field.name !== 'recordCount'
              );
            const filteredFields = response.filter(field => field.name !== 'recordCount'); // Filter out 'recordCount'
            setFields(filteredFields);
            setGroupFields([...group, { name: "created_at", label: "Created At" }]);
            setAggregationFields(aggregation);
        } catch (error) {
            message.error("Failed to fetch fields.");
        }
    };

     const handleFieldChange = (value) => {
        // if (value.length > 7) {
        //   message.error('You can select up to 7 fields.');
        //   return;
        // }
    
        setSelectedFields(value);
      };
     

    const fetchLookupRecordsForExistingFilters = (existingFilters) => {
        existingFilters.forEach(filter => {
            const selectedField = fields.find(field => field.name === filter?.field?.replace('_id', ''));
            if (selectedField && selectedField.type === 'lookup') {
                fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
            }
        });
    };
    // Function to fetch records for the lookup field
    const fetchLookupRecords = async (objectName) => {
        try {
            const apiServiceForRecords = new ApiService(
                `${BASE_URL}/fetch_records/${objectName}`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiServiceForRecords.makeCall();
        
            // Assuming response is an array of records with _id and Name fields
            const records = response?.records?.map(record => ({
                value: record._id, // Set _id as value
                label: record.Name, // Set Name as label
            }));
            setLookupOptions(records); // Set options for the lookup field
        } catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to save field due to an unknown error';
            message.error(errorMessage);
        }
    };

    return (
        <div>
            <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
                <Col>
                    <Title level={3}>Report Editor</Title>
                </Col>
                <Col>
                    <Button type="default" onClick={onBack}>
                        Back
                    </Button>
                </Col>
            </Row>

            <Spin spinning={loading}> {/* Wrap the content in a Spin component */}
                <Card>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            name="model"
                            label="Model"
                            rules={[{ required: true, message: "Please enter the model" }]}
                        >
                            <Select placeholder="Select a field" onChange={(e) => fetchfields(e)}>
                                {objects.map((ob) => (
                                    <Option key={ob.name} value={ob.name}>
                                        {ob.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="name"
                            label="Report Name"
                            rules={[{ required: true, message: "Please enter the report name" }]}
                        >
                            <Input placeholder="Enter report name" />
                        </Form.Item>

                        <Form.Item
                            name="description"
                            label="Description"
                        >
                            <Input.TextArea placeholder="Enter description" rows={4} />
                        </Form.Item>

                        <Form.Item
                            name="chart_type"
                            label="Chart Type"
                            rules={[{ required: true, message: "Please enter the model" }]}

                        >
                            <Select>
                                <Option value="bar">Bar</Option>
                                <Option value="line">Line</Option>
                                <Option value="pie">Pie</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="fields_to_display"
                            label="Fields to Display"
                        > 
                            <DynamicPicklistComponent
                            onChange={handleFieldChange}
                            isSelect={true}
                            selectedFields={selectedFields}
                            selectOptions={fields}
                            >
                            </DynamicPicklistComponent>
                            

                        </Form.Item>

                        <Form.Item
                            name="group_fields"
                            label="Group Fields"
                        >
                            <Select mode="multiple" placeholder="Select a field">
                                {groupFields.map((field) => (
                                    <Option key={field.name} value={field.name}>
                                        {field.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="aggregation_fields"
                            label="Aggregation Fields"

                        >
                            <Select mode="multiple" placeholder="Select a field">
                                {aggregationFields.map((field) => (
                                    <Option key={field.name} value={field.name}>
                                        {field.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <FiltersDynamic

                            fields={fields}
                            logic={logic}
                            setLogic={setLogic}
                            filters={filters}
                            setFilters={setFilters}
                            setValueOperator={setValueOperator}
                            valueOperator={valueOperator}
                            fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
                            fetchLookupRecords={fetchLookupRecords}
                            lookupOptions={lookupOptions}
                        >
                        </FiltersDynamic>

                        <Form.Item>
                            <Affix offsetBottom={0}>
                                <div
                                    style={{
                                        position: "sticky",
                                        bottom: 0,
                                        background: 'rgba(240, 242, 245, 0.9)',
                                        padding: "10px 0",
                                        boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
                                        textAlign: "center",
                                        marginBottom:0
                                    }}
                                >
                                    <Space>
                                        <Button type="primary" htmlType="submit">
                                            Save
                                        </Button>
                                        <Button htmlType="button" onClick={() => {

                                            form.resetFields()
                                            onBack();                                           
                                        }}>
                                            Cancel
                                        </Button>
                                    </Space>
                                </div>
                            </Affix>
                        </Form.Item>
                    </Form>
                </Card>
            </Spin>
        </div>
    );
};

export default ReportEditor;
